<template>
  <section class="container">
    <div class="header" :style="{
        backgroundImage:
          'url(' + require('@/assets/payment-related/payment1564@2x.png') + ')'
      }">
      <div class="header__info">
        <span class="header__info__title">{{
          $enumObject.providerConfig[config.projectName].provider.providerName
        }}</span>
        <span class="header__info__content">-{{
            $enumObject.providerConfig[config.projectName].provider
              .propagandaInfo
          }}-</span>
      </div>
    </div>
    <h3 class="prompt_tips">请输入车牌号查询费用</h3>
    <div class="page page-index">
      <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
    </div>
    <div class="btn_box">
      <van-button @click="submit" size="large" class="blue-btn">
        查询订单
      </van-button>
    </div>
  </section>
</template>

<script>
import keyboard from '@/components/keyboard/index'
import { getUrlParam } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Pay-Parking-Cost',
  components: { keyboard },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: []
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token'])
  },
  methods: {
    change (val) {
      this.plateNumber = val
    },
    submit () {
      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let plateNumberReg = new RegExp(
        '^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$'
      )
      if (!plateNumberReg.test(_this.plateNumber.join(''))) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      let params = {
        cardNumber: _this.plateNumber.join(''),
        parkId: getUrlParam('parkId')
      }
      this.$store.commit('transaction/SET_BILL_PARAMS', params)
      this.$router.push({
        name: 'Temporary-Parking-Cost',
        query: {
          cardNumber: window.encodeURI(_this.plateNumber.join('')),
          parkId: getUrlParam('parkId')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 20vh;
    min-height: 140px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__info {
      width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        color: #fff;
        text-align: center;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
  }

  .page {
    padding: 15px;
    margin: 10px 0 15vh;
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>